<div class="flyout-container"
    [class.open]="isOpen()"
    [class.position-left]="isLeftPosition()"
    [class.position-right]="!isLeftPosition()"
    [class.footer-fixed]="shouldPinFooter()"
    [class.keep-footer-visible-on-close]="keepFooterVisibleWhenClosed() && !isFullyClosed"
    [class.collapsed-footer-only]="!isOpen() && keepFooterVisibleWhenClosed() && !isFullyClosed"
    [style.width.%]="resolvedFlyoutWidth()"
    [style.height.%]="currentHeight"
    #flyout>
    <div class="flyout-content">
        <div class="chat-header">
            <div class="header-content">
                <img class="header-logo" src="../../../../assets/Ecolab-Virtual-Agent-Logo.svg" />
                <div class="header-right-controls">
                    <button class="header-corner-shape" type="button" aria-label="Collapse EVA panel"
                        (click)="$event.stopPropagation(); toggleFlyout()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none">
                            <path d="M72 0L72 72L-3.14722e-06 72L0 -3.14722e-06L72 0Z" fill="#006BD3" />
                        </svg>
                        <img class="corner-arrow-icon" src="../../../../assets/Icon-downward-arrow.svg" alt="" />
                    </button>
                    <span class="flyout-close" (click)="closeFlyout()">
                        <img class="close-icon" src="../../../../assets/close-darkblue.svg" />
                    </span>
                </div>
            </div>
        </div>
        <div class="panel-header-container">

            <!-- border-bottom: 2px solid lightgray;" -->
            <div class="header-sub-container">
                <div>
                    <ng-content select="[panelHeader]"></ng-content>
                </div>
                <div class="panel-toggle-button" (click)="toggleRightPanel()">
                    @if (!showRightPanel) {
                        <img style="transform: rotateY(180deg);" src="../../../../assets/Icon-Navigation.svg" />
                    }
                    <img src="../../../../assets/Icon-Communication.svg" />
                    @if (showRightPanel) {
                        <img src="../../../../assets/Icon-Navigation.svg" />
                    }
                    <span class="panel-toggle-button-text">{{'AI_AGENT.CHAT_HISTORY' | translate}}</span>
                </div>
            </div>
        </div>

        <div class="flyout-body">
            <div class="split-panels-container">
                <!-- Left Panel -->
                <div class="left-panel" [style.width.%]="leftPanelWidth">
                    <div class="panel-content">
                        <div class="left-panel-content">
                            <!-- Left panel content projection -->
                            <ng-content select="[leftPanel]"></ng-content>
                        </div>
                    </div>
                </div>

                <!-- Right Panel -->
                @if (showRightPanel) {
                    <div class="right-panel" [style.width.%]="rightPanelWidth">
                        <div class="panel-content">
                            <div class="right-panel-header">
                                <img src="../../../../assets/Icon-Communication-blue.svg" />
                                <span class="ms-2 chat-history">{{'AI_AGENT.CHAT_HISTORY' | translate}}</span>
                            </div>
                            <div class="right-panel-content">
                                <!-- Right panel content projection -->
                                <ng-content select="[rightPanel]" style="height: 100%;"></ng-content>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        @if (!isOpen() && keepFooterVisibleWhenClosed() && !isFullyClosed) {
            <button class="collapsed-open-control" type="button"
                (click)="openFlyout()" aria-label="Open EVA panel">
                <img class="collapsed-arrow-icon" src="../../../../assets/Icon-downward-arrow.svg" alt="" />
            </button>
        }
        <div class="flyout-footer">
            <div class="panel-footer-container">
                <!-- Left Panel -->
                <div class="footer-panel" [style.width.%]="leftPanelWidth">
                    <div class="panel-content">
                        <!-- Left panel content projection -->
                        <ng-content select="[panelFooter]"></ng-content>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="resize-handle" #resizeHandle (mousedown)="startResize($event)">
        <div class="resize-indicator"></div>
    </div>
</div>